import React from 'react';
import { LiveClassEventType } from 'components/LiveClass/utils/consts';
import { withTheme } from 'emotion-theming';
import * as s from './styles';

function NotificationMessage(props) {
  const { chat, theme, currentUser } = props;

  switch (chat.type) {
    case LiveClassEventType.CARD_COMPLETE: {
      const { user, card } = chat;
      const {
        name: cardName,
        content: { globalPosition }
      } = card;

      const isSelf = user.id === currentUser.id;
      const userName = isSelf ? 'You' : user.name;
      const cardTitle = `${globalPosition} ${cardName}`;

      return (
        <div className={s.notification(theme)}>
          <span className={s.bold}>{userName}</span>
          {isSelf ? ' have ' : ' has '}
          {'completed lesson '}
          <span className={s.bold}>{cardTitle}</span>
        </div>
      );
    }
    default:
      return null;
  }
}

export default withTheme(NotificationMessage);
